var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpTableMSU(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spTable_m_s_u",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.003,
    height: 56.003,
    viewBox: "0 0 56.003 56.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON_Table_Stop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_5766",
    "data-name": "\\u30D1\\u30B9 5766",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(11.995 12)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1497",
    "data-name": "\\u30D1\\u30B9 1497",
    d: "M0,0H56V56H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2707",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2707",
    transform: "translate(15.998 15.996)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3003",
    "data-name": "\\u9577\\u65B9\\u5F62 3003",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "table_bar_FILL1_wght400_GRAD0_opsz48",
    d: "M8,24l1.5-3.75a1.916,1.916,0,0,1,.725-.913A1.965,1.965,0,0,1,11.35,19h1.9V14.975A20.678,20.678,0,0,1,6.638,13.85Q4,12.85,4,11.5q0-1.45,2.925-2.475A21.5,21.5,0,0,1,14,8a21.5,21.5,0,0,1,7.075,1.025Q24,10.05,24,11.5q0,1.35-2.638,2.35a20.678,20.678,0,0,1-6.613,1.125V19h1.9a1.983,1.983,0,0,1,1.113.338,1.893,1.893,0,0,1,.738.913L20,24H18.5l-1.375-3.5H10.9L9.5,24Z",
    transform: "translate(-2.001 -4.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mute",
    transform: "translate(16.995 16.996)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_286",
    "data-name": "\\u7DDA 286",
    x2: 22,
    y2: 22,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_286-2",
    "data-name": "\\u7DDA 286",
    x2: 22,
    y2: 22,
    fill: "none",
    stroke: "#e8231e",
    strokeLinecap: "square",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpTableMSU);
export default __webpack_public_path__ + "static/media/spTable_m_s_u.37ff84eb8be20066a269caf70b8daacf.svg";
export { ForwardRef as ReactComponent };